export const STUDY_PROGRAM_QUERY_KEY_PREFIX = "study-program";
